import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/scss/Main.scss'
import './style.css'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import pinia from './stores'
import i18n from './locales'

// 建立實例、註冊 router、pinia、i18n、一次掛載
const app = createApp(App)
app.use(router)
app.use(pinia)
app.use(Antd)
app.use(i18n)
app.mount('#app')
